var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',_vm._g({attrs:{"variant":"link","data-sidebar":"menu-button"},nativeOn:{"click":function($event){_vm.$root.$emit('bv::hide::popover');
    _vm.$emit('click');}}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }